<p-dialog
(onHide)='hide()'

modal="true"
header="Country List" [(visible)]="visibleCountry" 
  [style]="{width: '500px', minWidth: '400px'}" [minY]="50" >
  

    <p-table #dt2 [value]="pays" dataKey="id"
    [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" 
    [paginator]="false" 
    [globalFilterFields]="['designationAn','designationFr' ]">
    <ng-template pTemplate="caption">
        <div class="flex">
            <span class="p-input-icon-left ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value, 'contains')" placeholder="Country FR/EN" />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Designation FR</th>
            <th>Designation EN</th>
   
        </tr>
     
    </ng-template>
    <ng-template pTemplate="body" let-country>
        <tr (click)="selectPays(country)">
            <td>
                {{country.designationFr}}
            </td>
            <td>
                {{country.designationAn}}
            </td>
            
        </tr>
    </ng-template>
 
</p-table>
   
  </p-dialog>
